var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('b-breadcrumb',{class:[{[`bg-${_vm.type}`]: _vm.type}, _vm.listClasses]},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }